import styled from '@emotion/styled'
import { Button, darken } from '@mui/material'
import { DatasetStatus } from '@components'
import { colors } from '@global/constants'
import { Submission } from '@global/types'
import { useApprovalContext } from '../contexts'
import { ActionType } from '../contexts/approvalContext/types'
import { t } from '@lingui/core/macro'

const StyledButton = styled(Button)`
  background-color: ${colors.blue.smokey};
  color: ${colors.white};

  &:hover {
    background-color: ${darken(colors.blue.smokey, 0.3)};
  }
`

interface Props {
  approvalRequest: Submission
}

export const ReviewButton = ({ approvalRequest }: Props) => {
  const { dispatch, showReviewingApprovalRequest } = useApprovalContext() ?? {
    dispatch: () => void {},
    showReviewingApprovalRequest: () => void {},
  }
  const disabled = approvalRequest.status === DatasetStatus.APPROVED

  return (
    <StyledButton variant="contained" disabled={disabled} onClick={handleClickReview}>
      {t`Review`}
    </StyledButton>
  )

  function handleClickReview() {
    dispatch({
      type: ActionType.setReviewingRequest,
      payload: {
        reviewingRequest: approvalRequest,
      },
    })

    showReviewingApprovalRequest(approvalRequest.dataset_id)
  }
}
